import React, { useState, useCallback } from "react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import InquiryModal from "@/components/landing/InquiryModal";
import FloatingInquiryButton from "@/components/landing/FloatingInquiryButton";

/**
 * Shared page shell for all sub-pages (Header + Footer + Inquiry modal + FAB).
 * Sub-pages render their SEO tags and content in {children}.
 */
export default function PageShell({ children }) {
  const [open, setOpen] = useState(false);
  const openInquiry = useCallback(() => setOpen(true), []);
  return (
    <div className="min-h-screen bg-white text-zinc-950 antialiased selection:bg-emerald-500 selection:text-white">
      <Header onOpenInquiry={openInquiry} />
      <main className="pt-24 md:pt-28">{children}</main>
      <Footer onOpenInquiry={openInquiry} />
      <FloatingInquiryButton onClick={openInquiry} />
      <InquiryModal open={open} onOpenChange={setOpen} />
    </div>
  );
}
